import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TagContainer" }
const _hoisted_2 = { class: "Tag Skeleton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noOfSkeletonTags, (_) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}